module.exports = __webpack_public_path__ + "static/media/art-books.bf1e5d99.mp4";